import React, {useEffect, useRef, useState} from 'react'
import imageUpload from '../../../img/imageUpload.webp'
import createPromotionImg from '../../../img/createPromotionImg.webp'
import {useTranslation} from 'react-i18next'
import {Spinner} from 'helpers'

type Props = {
 disabled?: boolean
 onImageSelect: (file: File) => void
 loading?: boolean
 imageUrl?: string
 textFlag?: boolean
}

const UploadThemeImage = ({
 onImageSelect,
 loading = false,
 imageUrl = '',
 disabled = false,
 textFlag = true,
}: Props) => {
 const {t} = useTranslation()
 const fileInputRef = useRef<HTMLInputElement>(null)
 const [preview, setPreview] = useState<string | null>(null)
 const [error, setError] = useState<string>('')
 const handleFileChange = (
  e: React.ChangeEvent<HTMLInputElement>
 ) => {
  if (disabled) return
  const file = e.target.files?.[0]
  if (!file) return

  if (!['image/jpeg', 'image/png'].includes(file.type)) {
   setError(
    t('createPromotion.uploadThemeImage.warningText')
   )
   return
  }

  if (file.size > 500 * 1024) {
   setError(
    t('createPromotion.uploadThemeImage.warningSizeText')
   )
   return
  }
  setError('')
  setPreview(URL.createObjectURL(file))
  onImageSelect?.(file)
 }

 useEffect(() => {
  if (imageUrl && !preview) {
   setPreview(imageUrl)
  }
 }, [imageUrl])

 return (
  <div className='mt-6'>
   <p className='font-medium mb-3'>
    {t('createPromotion.uploadThemeImage.title')}
    <span className='text-red-500'>*</span>
   </p>

   <div className='flex flex-wrap gap-6'>
    <div className='w-full md:w-[360px] border rounded-lg p-4 text-sm text-[#5A6066] flex gap-4 items-center'>
     <div>
      <p className='text-orange-500'>
       {' '}
       {t('createPromotion.uploadThemeImage.format')}
      </p>
      <p className='text-orange-500'>
       {t('createPromotion.uploadThemeImage.dimension')}
      </p>
      <p className='text-orange-500'>
       {t('createPromotion.uploadThemeImage.maxSize')}
      </p>
      <p className='mt-3'>
       {textFlag
        ? t('createPromotion.uploadThemeImage.note1')
        : t('createPromotion.uploadThemeImage.note2')}
      </p>
     </div>
     <img
      src={createPromotionImg}
      alt='Product Promotion Sample'
      className='w-[360px] rounded-lg border object-cover'
      style={{width: 108, height: 150}}
     />
    </div>

    <div
     className={`
     w-full sm:w-[260px] h-[300px]
    rounded-2xl
    bg-white
    flex-shrink-0
    flex flex-col items-center justify-center
    cursor-pointer
    transition-all
    border border-[#5E7CE2]
    relative 
  `}
     style={{
      boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
     }}
     onClick={() => {
      if (disabled || loading) return
      fileInputRef.current?.click()
     }}
    >
     {loading && (
      <div className='absolute inset-0 bg-white/70 flex items-center justify-center rounded-2xl'>
       <span className='animate-spin h-8 w-8 border-2 border-[#5E7CE2] border-t-transparent rounded-full' />
      </div>
     )}
     {preview ? (
      <img
       src={preview}
       alt='preview'
       style={{width: 108, height: 150}}
       className='w-[108px] h-[150px] object-cover rounded-lg'
      />
     ) : (
      <>
       <img
        src={imageUpload}
        alt='Product Promotion Sample'
        className='w-[360px] rounded-lg border object-cover'
        style={{width: 108, height: 150}}
       />
      </>
     )}
     <button
      className={` px-6 py-2 mt-4 rounded-lg  
    ${
     disabled
      ? 'bg-white text-[#C5CED6]  border border-[#C5CED6] cursor-not-allowed'
      : 'bg-[#5E7CE2] text-white cursor-pointer'
    }`}
      style={{borderRadius: 8}}
     >
      {loading ? (
       <Spinner />
      ) : preview ? (
       t('createPromotion.uploadThemeImage.changeImage')
      ) : (
       t('createPromotion.uploadThemeImage.uploadImage')
      )}
     </button>

     <input
      ref={fileInputRef}
      type='file'
      accept='image/png, image/jpeg'
      className='hidden'
      onChange={handleFileChange}
     />
    </div>
   </div>

   {error && (
    <p className='text-red-500 text-sm mt-2'>{error}</p>
   )}
  </div>
 )
}

export default UploadThemeImage
